import React, { CSSProperties, memo } from "react";
import Link from "next/link";
import { extractAccessibleLabel } from "@/utils/extractAccessibleLabel";

const CustomLink = ({
  field,
  activeStyles,
  customLinkLabel,
  customLinkHref,
  handleClickLink,
  children,
}: {
  field: any;
  activeStyles: CSSProperties;
  customLinkLabel: string;
  customLinkHref: string;
  handleClickLink: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  children: React.ReactNode;
}) => {
  const ariaLabel =
    field?.ariaLabel || extractAccessibleLabel(children) || "Medkart Image";

  return (
    <Link
      href={`${customLinkHref}`}
      target={field?.target ?? "_self"}
      id={field?.id ?? ""}
      className={field.className ?? ""}
      style={{
        ...(field?.style ?? {}),
        ...activeStyles,
      }}
      rel={field?.rel}
      prefetch={field?.prefetch ?? false}
      aria-label={ariaLabel}
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => handleClickLink(e)}
      download={field?.download ?? false}
    >
      {children}
      {customLinkLabel}
      {field?.postfix ?? ""}
    </Link>
  );
};

export default memo(CustomLink);
